import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PageMeta from '@/components/feature/PageMeta';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/categories';
import { getFeaturedArticles } from '@/mocks/articles';
import { faqItems } from '@/mocks/faq';

const featuredArticles = getFeaturedArticles(6);

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '奶水乐园',
  alternateName: '奶水乐园 - 母乳喂养妈妈的专属知识乐园',
  url: 'https://naishuileyuan.com',
  description: '专为哺乳期妈妈打造的母乳喂养知识平台，涵盖催奶食谱、追奶技巧、奶水不足解决方案、母乳储存方法及新生儿喂养指南。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://naishuileyuan.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '奶水乐园',
  url: 'https://naishuileyuan.com',
  description: '国内领先的母乳喂养知识分享平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-6688',
    contactType: 'customer service',
    email: 'hello@naishuileyuan.com',
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '建国路88号SOHO现代城A座1208室',
    addressLocality: '北京市朝阳区',
    addressCountry: 'CN',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <>
      <ScrollToTop />
      <PageMeta
        title="奶水乐园——母乳喂养妈妈的专属知识乐园"
        description="奶水乐园是专为哺乳期妈妈打造的母乳喂养知识平台，涵盖催奶食谱、追奶技巧、奶水不足解决方案、母乳储存方法及新生儿喂养指南，帮助每一位妈妈轻松实现纯母乳喂养，让宝宝健康成长。"
        keywords="奶水乐园,奶水不足怎么办,催奶食谱大全,追奶方法技巧,母乳喂养指南,奶水少的原因,母乳储存方法"
        canonicalUrl="https://naishuileyuan.com"
      />
      <SchemaOrg data={websiteSchema} />
      <SchemaOrg data={organizationSchema} />
      <SchemaOrg data={faqSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* ===== Hero Section ===== */}
        <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=soft%20warm%20abstract%20background%20with%20gentle%20curves%20and%20organic%20shapes%2C%20cream%20and%20blush%20peach%20tones%2C%20minimalist%20art%20style%2C%20calming%20and%20nurturing%20atmosphere%2C%20subtle%20gradient%2C%20no%20text%2C%20no%20people%2C%20abstract%20flowing%20lines%2C%20soft%20watercolor%20texture&width=1800&height=800&seq=hero-bg-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/25"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center text-white">
              <div className="flex items-center justify-center gap-3 mb-6">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <i className="ri-drop-fill text-white text-2xl md:text-3xl"></i>
                </div>
              </div>
              <h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
                奶水乐园
              </h1>
              <p className="text-base md:text-xl text-white/90 mb-2 leading-relaxed">
                母乳喂养妈妈的专属知识乐园
              </p>
              <p className="text-sm md:text-base text-white/75 mb-8 max-w-2xl mx-auto leading-relaxed">
                涵盖催奶食谱、追奶技巧、奶水不足解决方案、母乳储存方法及新生儿喂养指南，帮助每一位妈妈轻松实现纯母乳喂养，让宝宝健康成长。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/cuinai-recipes"
                  className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
                >
                  探索催奶食谱
                </Link>
                <Link
                  to="/category/milk-boost-tips"
                  className="px-6 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer border border-white/30"
                >
                  学习追奶技巧
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* ===== Category Navigation ===== */}
        <section className="py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                探索知识分类
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                五大知识板块，全面覆盖母乳喂养的每一个重要环节
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/60 rounded-xl p-5 hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="w-10 h-10 rounded-lg bg-primary-100/80 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                    <i className={`${cat.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Featured Articles ===== */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  精选文章
                </h2>
                <p className="text-sm text-foreground-600">专业、实用的母乳喂养知识，总有一篇能帮到你</p>
              </div>
              <Link
                to="/category/cuinai-recipes"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => {
                const cat = categories.find((c) => c.slug === article.category);
                return (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
                  >
                    <div className="h-48 overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                          {cat?.name || ''}
                        </span>
                        <span className="text-xs text-foreground-500">{article.readTime} 分钟阅读</span>
                      </div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="mt-3 pt-3 border-t border-background-200/60 flex items-center justify-between">
                        <span className="text-xs text-foreground-500">{article.publishDate}</span>
                        <span className="text-xs text-primary-600 font-medium flex items-center gap-0.5 whitespace-nowrap">
                          阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* ===== Stats Section ===== */}
        <section className="py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { number: '50万+', label: '累计服务妈妈' },
                { number: '500+', label: '原创专业文章' },
                { number: '98%', label: '用户好评率' },
                { number: '30+', label: '认证专家团队' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                    {stat.number}
                  </div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== FAQ Section ===== */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                常见问题
              </h2>
              <p className="text-sm text-foreground-600">妈妈们最关心的母乳喂养问题，这里都有答案</p>
            </div>
            <div className="space-y-3">
              {faqItems.map((faq, i) => (
                <div
                  key={i}
                  className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full flex items-center justify-between p-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                  >
                    <span className="text-sm font-medium text-foreground-950 pr-4">{faq.question}</span>
                    <i className={`ri-${openFaq === i ? 'subtract' : 'add'}-line text-foreground-500 text-lg flex-shrink-0 transition-transform`}></i>
                  </button>
                  {openFaq === i && (
                    <div className="px-4 pb-4">
                      <div className="pt-3 border-t border-background-200/60">
                        <p className="text-sm text-foreground-700 leading-relaxed">{faq.answer}</p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== CTA Section ===== */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-secondary-500">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              加入奶水乐园，让哺乳之路更轻松
            </h2>
            <p className="text-sm md:text-base text-background-50/85 mb-8 leading-relaxed">
              每一位妈妈都值得被温柔以待，我们在这里等你
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/feeding-guide"
                className="px-6 py-3 bg-background-50 hover:bg-background-100 text-secondary-600 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
              >
                开始学习
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-secondary-600 hover:bg-secondary-700 text-background-50 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}